import { render, staticRenderFns } from "./createSubscription.vue?vue&type=template&id=5fa8c401"
import script from "./createSubscription.vue?vue&type=script&lang=js"
export * from "./createSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports